<template>
  <!-- 案例查看 -->
  <div class="case-content">
    <h3 class="artical-title">{{caseObj.case_name}}</h3>
    <div class="artical-info">
      <span>发布日期：{{caseObj.report_time}}</span> <span class="line"></span>
      <span>访问量： {{caseObj.hit_count}} </span> <span class="line"></span>
      <span>字体：[ <span class="fontChange" @click="size=3">大</span> <span class="fontChange"
                                                                         @click="size=2">中</span> <span
        class="fontChange" @click="size=1">小</span> ]</span>
    </div>
    <div class="case-box">
      <div class="case-item">
        <h3>案例简介</h3>
        <div class="txt" v-show="caseObj.case_info">
          <p :class="'txt_'+size">{{caseObj.case_info}}</p>
        </div>
      </div>
      <div class="case-item" v-show="caseObj.case_content">
        <h3>案例内容</h3>
        <div class="txt">
          <p :class="'txt_'+size">{{caseObj.case_content}}</p>
        </div>
      </div>
      <div class="case-item" v-show="caseObj.handle_process">
        <h3>处理过程</h3>
        <div class="txt">
          <p :class="'txt_'+size">{{caseObj.handle_process}}</p>
        </div>
      </div>
      <div class="case-item" v-show="caseObj.case_info">
        <h3>处理结果</h3>
        <div class="txt">
          <p :class="'txt_'+size">{{caseObj.handle_result}}</p>
        </div>
      </div>
      <div class="case-item" v-show="caseObj.maintain_platform">
        <h3>案例来源</h3>
        <div class="txt">
          <p :class="'txt_'+size">{{caseObj.maintain_platform}}</p>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <a-button type="primary" @click="closeCase">关闭</a-button>
    </div>
  </div>
</template>
<script>
  import {getOneCase,hit} from '@/api/case';

  export default {
    name: 'CaseView',
    props: ['id'],
    data() {
      return {
        caseObj: {},
        size: 1,
      }
    },
    created() {
      console.log(this.id);
      this.initOneCase();
      hit({pkid:this.id});
    },
    methods: {
      async initOneCase() {
        console.log(this.id);
        let p = {id: this.id};
        this.caseObj = await getOneCase(p);
      },
      closeCase() {
        window.close();
      }
    }
  };
</script>
<style scoped>
  .case-content {
    padding: 0 10px;
  }

  .fontChange {
    cursor: pointer;
  }

  .txt_1 {
    font-size: 14px;
  }

  .txt_2 {
    font-size: 16px;
  }

  .txt_3 {
    font-size: 18px;
  }

  .artical-title {
    font-weight: normal;
    color: #333;
    font-size: 24px;
    font-family: '微软雅黑';
    text-align: center;
    margin-bottom: 0;
    line-height: 1;
    padding: 15px 0 30px 0;
  }

  .artical-info {
    height: 28px;
    line-height: 28px;
    background: #f7f9fa;
    border: 1px solid #dbdee1;
    text-align: center;
    font-size: 14px;
    color: #999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .artical-info span {
    display: inline-block;
  }

  .line {
    width: 2px;
    height: 15px;
    background: #c2c3c3;
    margin: 0 25px;
  }

  .case-box {
    margin-top: 10px;
  }

  .case-item {
    border: 1px solid #e4eaf2;
  }

  .case-item h3 {
    height: 50px;
    line-height: 50px;
    background: #fafbfc;
    color: #4595f1;
    font-family: '微软雅黑';
    font-weight: normal;
    font-size: 16px;
    padding-left: 20px;
    border-bottom: 1px solid #e4eaf2;
  }

  .case-item .txt {
    padding: 0 12px;
  }

  .case-item p {
    line-height: 40px;
  }

  .case-item ul li {
    list-style: none;
    line-height: 40px;
    padding: 0 15px;
  }

  .case-item + .case-item {
    margin-top: 10px;
  }

  .btn-box {
    text-align: center;
    padding: 40px 0;
  }
</style>
